/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgAnalyticsData = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M51 12a7 7 0 0 0-4.68 12.2L40.55 36a4.57 4.57 0 0 0-2.69.92L27 31.5a4.5 4.5 0 1 0-8.15 2.62L13.63 44a5.849 5.849 0 0 0-.73 0 7 7 0 1 0 4.44 1.59L22.39 36h.11a4.44 4.44 0 0 0 2.71-.93l10.86 5.39a4.501 4.501 0 1 0 8.06-2.72l5.79-11.8c.358.044.72.064 1.08.06a7 7 0 0 0 0-14ZM12.9 54a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM51 22a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
}));

export default SvgAnalyticsData;